export default __webpack_public_path__ + "static/EverydaygoalDrivenCulture1-95ac86193ef4b4c6e243d6615f39e33f.png";